import { modelHasTemplates } from 'reducers/models/selectors';

export const announcementsLoading = ({ loading }) => loading.announcements;
export const cartLoading = ({ loading }) => loading.cart;
export const cartSubmissionLoading = ({ loading }) => loading.cartSubmission;
export const dashboardLoading = ({ loading }) => loading.dashboard;
export const modelTemplatesLoading = ({ loading }) => loading.modelTemplates;
export const modelTemplatesLoaded = ({ loading }) => !loading.modelTemplates;
export const modelCompetitionLoaded = ({ loading }) =>
  !loading.modelCompetition;
export const modelTemplatesWorkingStateLoading = ({ loading }) =>
  loading.modelTemplatesWorkingState;
export const modelTemplatesWorkingStateLoaded = ({ loading }) =>
  !loading.modelTemplatesWorkingState;
export const seriesAllocationLoading = ({ loading }) =>
  loading.seriesAllocation;
export const seriesAllocationLoaded = ({ loading }) =>
  !loading.seriesAllocation;
export const templateDetailImagesLoading = ({ loading }) =>
  loading.templateDetailImages;
export const workingStateSubmissionLoading = ({ loading }) =>
  loading.workingStateSubmission;
export const seriesDetailPageLoaded = (state, props) =>
  modelHasTemplates(state, props) ||
  (modelTemplatesLoaded(state) && seriesAllocationLoaded(state));
